import { useMe } from '@/lib/me';

/**
 * Whether the caller may load the time-entry picker inputs
 * (`/timesheets/in-scope-activities`, `/recent-activities`, `/engagements`).
 * The server gates all three on `timesheet.edit` OR `timer.edit`; a
 * view-only caller (e.g. `timesheet.view` alone) would only collect a 403 and
 * an error toast, so the hooks skip the request instead.
 *
 * `pending` is true while `/me` is in flight: the hooks must report "not
 * loaded yet" then, not "loaded, nothing here" — the grid would otherwise
 * briefly read every entry as unattributed.
 */
export function useCanEnterTime(): { allowed: boolean; pending: boolean } {
  // The caller's own grants, not a record's unit: these endpoints aren't
  // record-scoped (same answer `useHasPermission` gives outside a
  // RecordUnitProvider).
  const { permissions, loading } = useMe();
  return {
    allowed: permissions.has('timesheet.edit') || permissions.has('timer.edit'),
    pending: loading === true,
  };
}
